export default __webpack_public_path__ + "assets/images/91027f69fdda35cae40a2113905e1bda.svg";